import { render, staticRenderFns } from "./PartnerLoanRepayment.vue?vue&type=template&id=766aed8a&"
import script from "./PartnerLoanRepayment.vue?vue&type=script&lang=js&"
export * from "./PartnerLoanRepayment.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLoanRepayment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PartnerLoanRepayment.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PartnerLoanRepayment.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFileInput,VSelect})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
